import { ViewModel } from 'view_models/view_model'
import { Dna } from 'entities/dna'
import { Badge } from 'react-bootstrap'

export class DnaViewModel extends ViewModel<Dna> {
    public dateText = (): string => {
        return this.toDateText(this.object.date)
    }

    public qcStatus = (): JSX.Element => {
        if (this.object.isQcOk === false) {
            return <Badge bg="danger">NG</Badge>
        } else if (this.object.isQcOk === true) {
            return <Badge bg="success">OK</Badge>
        } else {
            return <Badge bg="warning">QC待ち</Badge>
        }
    }
}
